
export type FaqEntry = {
    id: number;
    title: string;
    content: string;
}

let FaqEntries:FaqEntry[] = [
    {
        id: 1,
        title: "What Date should I RSVP BY?",
        content: "Please RSVP online by May 15th"
    },
    {
        id: 2,
        title: "What time should I arrive at your wedding ceremony?",
        content: "We recommend arriving at the ceremony venue at least 30 minutes ahead of the ceremony start time to ensure you have enough time to park, locate to the ceremony space and find a seat. Guests will have access to the ceremony space at 12pm and our ceremony will begin promptly at 12:30pm."
    },
    {
        id: 3,
        title: "Can I take photos during the ceremony?",
        content: "We're having an unplugged ceremony, so we kindly ask guests to keep phones and cameras tucked away until after."
    },
    {
        id: 4,
        title: "Am I allowed to bring a plus-one?",
        content: "We've chosen to keep the guest list just to those who know us well so we are not allowing additional plus ones."
    },
    {
        id: 5,
        title: "Will the wedding be indoors or outdoors?",
        content: "Our ceremony at Phipps Conservatory & Botanic Garden will be outdoors. The cocktail hour and reception at the WBU Event Center will be held indoors with outdoor patio access."
    },
    {
        id: 6,
        title: "What's the dress code for your wedding?",
        content: "Our dress code is black-tie optional. We ask that you wear a dark suit and tie or tuxedo. Alternatively, an evening gown or a midi- or knee- length cocktail dress would be appropriate."
    },
    {
        id: 7,
        title: "Where do I park at the Phipps Conservatory & Botanic Garden?",
        content: "Free parking is available in the center island on Schenley Drive. Metered street parking is available on either side of Schenley Drive. The closest parking garage is Sennott Square Garage located at 207 South Bouquet Street (~15 minute walk). Please plan on arriving with ample time to find parking."
    },
    {
        id: 8,
        title: "What should I do in the time between your ceremony & cocktail hour?",
        content: "Every guest will be given a ticket to visit Phipps Conservatory & Botanic Garden following the ceremony. An average self-guided tour takes approximately 90 minutes, but we find that you could easily spend an entire day enjoying the beauty and serenity of both the indoor and outdoor gardens. Check out our 'Things to Do' tab for more suggestions of places to visit in the area!"
    },
    {
        id: 9,
        title: "Have you reserved blocks of rooms at one or more hotels?",
        content: "We have reserved room blocks at Kimpton Hotel Monaco Pittsburgh & Homewood Suites by Hilton Pittsburgh Downtown. Please visit the 'Accommodations' tab on this site and click the link for your preferred hotel to book your room. Reservations must be made by May 10th, 2026 to receive our discounted rate."
    },
    {
        id: 10,
        title: "Will there be a shuttle to/from the hotels for the wedding events?",
        content: "We will be providing a shuttle from the hotels to/from the WBU Event Venue. Alternatively, and for those not staying at the hotels, rideshare options are available in the area. Guests are able to park their cars in the WBU parking lot overnight. We will not be providing a shuttle from the hotels to/from Phipps Conservatory & Botanic Gardens due to the variable timing of the afternoon."
    },
    {
        id: 11,
        title: "What type of food will be served at your wedding?",
        content: "We'll be serving hors d'oeuvres at cocktail hour followed by a buffet style dinner. There will be beef, chicken, fish, & vegetarian options. Speciality meals will be provided for those with allergies and dietary restrictions (gluten-free, vegan, dairy-free, etc). Please include any allergies/dietary restrictions when completing your RSVP."
    },
    {
        id: 12,
        title: "Will there be an open bar?",
        content: "Yes, there will be an open bar for guests to enjoy throughout cocktail hour and the reception, We want to ensure you get home safely after our special day. Please consider using the shuttle, rideshare services or arranging a designated driver in advance."
    }
];

export default FaqEntries;
